import { ActionReducer } from '@ngrx/store';
import { CompanySearch } from 'src/app/core/models/business-profile/companySearch.model';
import { Address } from 'src/app/core/models/common/address.model';
import { StateManagementHelpers } from '../../helpers';
import * as BusinessProfileActions from '../actions/business-profile.actions';
import { IBusinessProfileStore } from '../interfaces/business-profile-store.interface';

const defaultBusinessProfile: IBusinessProfileStore = {
  businessType: { id: -1, value: '' },
  businessIndustry: { id: -1, value: '' },
  businessDescription: '',
  customerTypes: [],
  stateOfOrg: { id: -1, value: '' },
  dba: '',
  companyAddress: new Address(),
  annualRevenue: { id: -1, value: '' },
  companyWebsite: '',
  yearFounded: 0,
  employeeCount: { id: -1, value: '' },
  invoicingMethod: { id: -1, value: '' },
  supportMethods: [],
  companySearch: new CompanySearch(),
};

export const businessProfileReducer: ActionReducer<
  IBusinessProfileStore | undefined,
  any
> = (
  // eslint-disable-next-line default-param-last
  state: IBusinessProfileStore = defaultBusinessProfile,
  action: any
): IBusinessProfileStore | undefined => {
  switch (action.type) {
    case BusinessProfileActions.BUSINESS_TYPE:
      return StateManagementHelpers.mergeState(state, {
        businessType: action.businessType,
      }) as IBusinessProfileStore;
    case BusinessProfileActions.BUSINESS_INDUSTRY:
      return StateManagementHelpers.mergeState(state, {
        businessIndustry: action.businessIndustry,
      }) as IBusinessProfileStore;
    case BusinessProfileActions.BUSINESS_DESCRIPTION:
      return StateManagementHelpers.mergeState(state, {
        businessDescription: action.businessDescription,
      }) as IBusinessProfileStore;
    case BusinessProfileActions.CUSTOMER_TYPES:
      return StateManagementHelpers.mergeState(state, {
        customerTypes: action.customerTypes,
      }) as IBusinessProfileStore;
    case BusinessProfileActions.STATE_OF_ORG:
      return StateManagementHelpers.mergeState(state, {
        stateOfOrg: action.stateOfOrg,
      }) as IBusinessProfileStore;
    case BusinessProfileActions.DBA:
      return StateManagementHelpers.mergeState(state, {
        dba: action.dba,
      }) as IBusinessProfileStore;
    case BusinessProfileActions.COMPANY_ADDRESS:
      return StateManagementHelpers.mergeState(state, {
        companyAddress: action.companyAddress,
      }) as IBusinessProfileStore;
    case BusinessProfileActions.ANNUAL_REVENUE:
      return StateManagementHelpers.mergeState(state, {
        annualRevenue: action.annualRevenue,
      }) as IBusinessProfileStore;
    case BusinessProfileActions.COMPANY_WEBSITE:
      return StateManagementHelpers.mergeState(state, {
        companyWebsite: action.companyWebsite,
      }) as IBusinessProfileStore;
    case BusinessProfileActions.YEAR_FOUNDED:
      return StateManagementHelpers.mergeState(state, {
        yearFounded: action.yearFounded,
      }) as IBusinessProfileStore;
    case BusinessProfileActions.EMPLOYEE_COUNT:
      return StateManagementHelpers.mergeState(state, {
        employeeCount: action.employeeCount,
      }) as IBusinessProfileStore;
    case BusinessProfileActions.INVOICING_METHOD:
      return StateManagementHelpers.mergeState(state, {
        invoicingMethod: action.invoicingMethod,
      }) as IBusinessProfileStore;
    case BusinessProfileActions.COMPANY_SEARCH:
      return StateManagementHelpers.mergeState(state, {
        companySearch: action.companySearch,
      }) as IBusinessProfileStore;
    case BusinessProfileActions.SUPPORT_METHODS:
      return StateManagementHelpers.mergeState(state, {
        supportMethods: action.supportMethods,
      }) as IBusinessProfileStore;
    case BusinessProfileActions.LegacyUpgradeAction:
      return StateManagementHelpers.mergeState(state, {
        businessIndustry: action.businessIndustry,
        customerTypes: action.customerTypes,
        stateOfOrg: action.stateOfOrg,
        dba: action.dba,
        companyAddress: action.companyAddress,
        annualRevenue: action.annualRevenue,
        companyWebsite: action.companyWebsite,
        yearFounded: action.yearFounded,
        employeeCount: action.employeeCount,
        invoicingMethod: action.invoicingMethod,
        supportMethods: action.supportMethods,
      }) as IBusinessProfileStore;
    case BusinessProfileActions.ALL:
      return StateManagementHelpers.mergeState(state, {
        businessType: action.businessType,
        businessIndustry: action.businessIndustry,
        businessDescription: action.businessDescription,
        customerTypes: action.customerTypes,
        stateOfOrg: action.stateOfOrg,
        dba: action.dba,
        companyAddress: action.companyAddress,
        annualRevenue: action.annualRevenue,
        companyWebsite: action.companyWebsite,
        yearFounded: action.yearFounded,
        employeeCount: action.employeeCount,
        invoicingMethod: action.invoicingMethod,
        companySearch: action.companySearch,
        supportMethods: action.supportMethods,
      }) as IBusinessProfileStore;
    default:
      return state;
  }
};
